import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore, pluralize } from '@mcn-platform/models';
import ModuleView from '../item/ModuleView';
const SearchResults = ({ title, modelName, searchTerm, }) => {
    const store = useStore();
    // Memoize filter for unified search API (organizationId, libraryIds, text, searchableOnly).
    const combinedFilter = useMemo(() => {
        const portal = store.currentPortal;
        const organizationId = portal?.organizationID ?? '';
        const libraryIds = new Set();
        if (portal.defaultLibrary?.id) {
            libraryIds.add(portal.defaultLibrary.id);
        }
        portal.libraries.forEach((library) => {
            libraryIds.add(library.id);
        });
        portal.libraryShares.forEach((share) => {
            libraryIds.add(share.libraryID);
        });
        const sortedLibraryIds = [...libraryIds].sort();
        return {
            organizationId,
            libraryIds: sortedLibraryIds,
            searchableOnly: true,
            text: searchTerm?.length ? searchTerm : undefined,
        };
    }, [
        store.currentPortal?.id,
        store.currentPortal?.organizationID,
        store.currentPortal?.defaultLibrary?.id,
        store.currentPortal?.libraries,
        store.currentPortal?.libraryShares,
        searchTerm,
        modelName,
    ]);
    const cachedList = store.getCachedList(modelName, combinedFilter, undefined, true);
    cachedList.setRequestedCount(50);
    const getTitle = () => {
        if (['loading', 'stubbed'].includes(cachedList.syncState)) {
            return `Loading ${pluralize(title)}...`;
        }
        if (cachedList.totalCount > 0) {
            if (cachedList.totalCount > 1) {
                return `${cachedList.totalCount} ${pluralize(title)} Available`;
            }
            return `${cachedList.totalCount} ${title} Available`;
        }
        return `No ${pluralize(title)} Available`;
    };
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h2", sx: { m: 1, textAlign: 'center' }, children: getTitle() }), _jsx(ModuleView, { items: cachedList.items })] }));
};
SearchResults.defaultProps = {};
export default observer(SearchResults);
//# sourceMappingURL=SearchResults.js.map